export default __webpack_public_path__ + "static/media/twitter.9f8c1218.svg";